// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import React from 'react'
import ReactDOM from 'react-dom'
// import {BrowserRouter} from 'react-router-dom'
// import React from 'react'
// import ReactDOM from 'react-dom'

// import Data from '@/components/Data'

// import "./assets/styles/home.scss"

import Home from './components/Home'

import project from '../project'

function reactRender() {
  ReactDOM.render(
    <Home className="nnd-app" />,
    document.getElementById(`app_${project.name}`)
  )
}

reactRender()

// export default ReactDOM


// WEBPACK FOOTER //
// ./src/index.js